import { MergedPermission } from 'modules/roles/types';
import { getCheckboxStatus } from 'modules/roles/utils';
import styled from 'styled-components';
import { Checkbox } from 'ui/checkbox';
import { Body2, body2, colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { camelCase } from 'utils/stringHelpers';

const Field = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-areas: 'input label' '. description';
  column-gap: ${spacing.half};

  @media (min-width: ${pxToRem(720)}) {
    grid-template-columns: auto minmax(${pxToRem(120)}, 1fr) minmax(${pxToRem(120)}, 2fr);
    grid-template-areas: 'input label description';
  }
`;

const Input = styled(Checkbox)`
  grid-area: input;
  margin-top: ${spacing.eighth};
`;

const Label = styled.label`
  ${body2}
  grid-area: label;
  cursor: pointer;
`;

const Description = styled(Body2)`
  grid-area: description;
  color: ${colors.textSecondary};
`;

type CheckboxProps = {
  permission: MergedPermission | undefined;
  handleChange: (id: number) => void;
  currentState: number[];
};

export const CheckboxField = ({ permission, handleChange, currentState = [] }: CheckboxProps) => {
  if (!permission) return <></>;

  const { description, id, name, requiredBy } = permission;
  const status = getCheckboxStatus(permission, currentState);
  const isDisabled = requiredBy.some((num) => currentState.includes(num));
  const camelCaseName = camelCase(name);

  return (
    <Field>
      <Input
        isDisabled={isDisabled}
        name={camelCaseName}
        onClick={() => handleChange(id)}
        status={status}
      />
      <Label htmlFor={camelCaseName} onClick={() => !isDisabled && handleChange(id)}>
        {name}
      </Label>
      {description && <Description>{description}</Description>}
    </Field>
  );
};
